// istanbul ignore file
import { createTheme, Theme } from "@mui/material/styles";

const colors = {
  palette: {
    primary: {
      main: "#2460AB",
    },
    yellow: {
      main: "#FFA929",
      dark: "#D3702A",
    },
    red: {
      main: "#C80E0E",
    },
    secondary: {
      main: "#0ab093",
    },
    error: {
      main: "#E1242A",
    },
    success: {
      main: "#00A947",
    },
    gray: {
      light: "#CBCBCB",
      dark: "#6B7280",
      darker: "#6E6E6E",
      bg: "#F0F2F5",
    },
  },
};

const theme = createTheme(
  {
    shape: {
      borderRadius: 10,
    },
    ...colors,
    typography: {
      fontFamily: "Roche Sans",
    },
  },
  {
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: "capitalize",
            borderRadius: "2px",
          },
        },
      },
    },
  },
);

export default theme as Theme & typeof colors;
